import apiGetRequest from './base/api-get-request'

const getPublicDataValidation = (slug) => {
    return apiGetRequest(`/snowflake-validation`)()
}

export default getPublicDataValidation